import $ from "jquery";
import {AJAX} from "./ajax";
import {forEach, assign} from "./framework/voidash.js";

const defaultAttr = "popover";
const tooltipAttr = "popover-tooltip";

const defaultSelector = `[data-toggle='${defaultAttr}']:not([tabindex])`;
const focusSelector = `[data-toggle='${defaultAttr}'][tabindex]`;
const tooltipSelector = `[data-toggle='${tooltipAttr}']`;
const selector = `${defaultSelector},${focusSelector},${tooltipSelector}`;

const commonPopoverOpts = {
  trigger: "manual",
  placement: "auto",
  html: true,
  container: "body"
};

assign($.fn.popover.Constructor.Default.whiteList, {
  table: [],
  tr: [],
  td: [],
  th: [],
  div: [],
  tbody: [],
  thead: [],
});

$(function () {
  let targets = [];

  const $body = $("body");

  $body
    .on("click", defaultSelector, function () {
      $(this)
        .popover(commonPopoverOpts)
        .popover("toggle");
    })

    .on("focusin", focusSelector, function () {
      $(this)
        .popover(commonPopoverOpts)
        .popover("show")
        .data("void.popover-focus.shown", Date.now());
    })

    .on("click", focusSelector, function () {
      const $this = $(this);
      const shown = $this.data("void.popover-focus.shown");
      if (shown && Date.now() - shown > 100) {
        $this.popover("toggle");
      }
    })

    .on("focusout", focusSelector, function () {
      $(this)
        .popover("hide")
        .data("void.popover-focus.shown", 0);
    })

    .on("mouseenter", tooltipSelector, function () {
      $(this)
        .popover(commonPopoverOpts)
        .popover("show");
    })

    .on("mouseleave", tooltipSelector, function () {
      $(this).popover("hide");
    })

    .on("show.bs.popover", function ($evt) {
      if (!$($evt.target).is(selector)) targets.push($evt.target);
    })

    .on("hide.bs.popover", function ($evt) {
      targets = targets.filter(t => t !== $evt.target);
    });

  AJAX.onRequest(function(opts) {
    if(!opts.__nopopover) {
      $(targets).popover("hide");
    }
  });

  const origFns = {
    remove: $.fn.remove,
    detach: $.fn.detach,
    replaceWith: $.fn.replaceWith
  };

  forEach(origFns, (origFn, key) => {
    $.fn[key] = function () {
      targets.slice().forEach(t => {
        this.each((i, el) => {
          if($.contains(el, t)) $(t).popover("hide");
        });
      });

      return origFn.apply(this, arguments);
    };
  });

  $body.on("click", function($evt) {
    if(!$($evt.target).is(".popover *")) {
      targets.slice().forEach(t => {
        if(!$.contains(t, $evt.target)) $(t).popover("hide");
      });
    }
  });
});
